import XMLWriter from "xml-writer"
import fetch from "cross-fetch"
import { DEV,domain,quoterurl,RWSURL,RBURL,EZLURL } from "../../app/settings";
import moment from 'moment';

// A mock function to mimic making an async request for data
export async function fetchQuote(fields) {
    
    var RWSv3Request = make_XML_Request('Quote',fields,fields.user.guid.value,generateUUID());
    var RBv3Request = make_XML_Request('Rate',fields,fields.user.guid.value,generateUUID());
    var EZLv3Request = make_XML_Request('RecordFortusLead',fields,fields.user.guid.value,generateUUID());

    const fetchRWSv3Request = fetch("https://myinsurancebroker.com/api/quoter/rws",{method: 'POST', headers:{'Content-Type': 'application/x-www-form-urlencoded'},body: new URLSearchParams({data:RWSv3Request}),redirect: 'follow'});
    const fetchRBv3Request = fetch("https://myinsurancebroker.com/api/quoter/rb",{method: 'POST', headers:{'Content-Type': 'application/x-www-form-urlencoded'},body: new URLSearchParams({data:RBv3Request}),redirect: 'follow'});
    const fetchEZLv3Request = fetch("https://myinsurancebroker.com/api/quoter/ez",{method: 'POST', headers:{'Content-Type': 'application/x-www-form-urlencoded'},body: new URLSearchParams({data:EZLv3Request}),redirect: 'follow'});

    
    if(!DEV)
      var [RWSv3, RBv3, EZLv3] = await Promise.all([fetchRWSv3Request,fetchRBv3Request,fetchEZLv3Request]);
    else
      var [RWSv3, RBv3] = await Promise.all([fetchRWSv3Request,fetchRBv3Request]);
    
    RWSv3 = await RWSv3.text();
    RBv3 = await RBv3.text();

    return {RWSv3:RWSv3, RBv3:RBv3};
}
  

function make_XML_Request(method,fields,guid,iguid){

    var xw = new XMLWriter();
    xw.formatting = 'indented';//add indentation and newlines
    xw.indentChar = ' ';//indent with spaces
    xw.indentation = 2;//add 2 spaces per level
    xw.startDocument( );
    xw.startElement( method );

      if (method === 'Quote') {
        xw.writeAttribute( 'xmlns', 'http://www.compu-quote.com/RatingWebService/Version1');
      } else if (method === 'Rate') {
        xw.writeAttribute( 'xmlns', 'http://www.compu-quote.com/RateBridge/Version1');
      } else if (method === 'RecordFortusLead') {
        xw.writeAttribute( 'xmlns', 'http://www.compu-quote.com/EzLeadsWebService/');
        xw.writeElement('QuoteGUID', guid);
        xw.writeElement('From', 'MyInsuranceBroker');
        xw.writeElement('To', fields.user.brkr.value); //user_brkr
        xw.startElement( 'FortusQuote' );
      }
      
      if (method !== 'RecordFortusLead') {
        xw.writeElement('QuoteGUID', guid);
        xw.writeElement('QuoteIterationGUID', iguid);
        xw.startElement( 'xmlparam_FortusTransaction' );
      }
        xw.startElement( 'FortusTransaction' );
          xw.writeAttribute( 'xmlns', 'deletethis');
          xw.writeAttribute( 'Type', 'Automobile');
          xw.writeElement('EffDate', moment().format('YYYYMMDD'));
          xw.writeElement( 'Province', 'ON');
          xw.writeElement('Renewal', 'NO');
          xw.startElement( 'Carriers' );
          if (method === 'Quote' || method === 'RecordFortusLead') {
            
            if(fields.user.brkr.value == "MIBF2"){
              xw.writeElement('Carrier','JEV'); //Entuitive
              xw.writeElement('Carrier','ECGL'); // Entuitive
            }else{

              xw.writeElement('Carrier','JEV'); //Entuitive
              
              //    Carriers to be enabled in Q2 2019:
              // xw.writeElement('Carrier','LOMI');
              xw.writeElement('Carrier','PEM');
              //xw.writeElement('Carrier','ECGL'); // Entuitive
              // xw.writeElement('Carrier','TOWN');

              //    Carriers disabled due to change in contracting:
              // xw.writeElement('Carrier','ROY');

              // xw.writeElement('Carrier','PERT');
              // xw.writeElement('Carrier','FAC');
            }
          } else if (method === 'Rate' || method === 'RecordFortusLead') {
            if(fields.user.brkr.value == "MIBF2"){
              xw.writeElement('Carrier','GORE'); //Entuitive
              xw.writeElement('Carrier','GA');   //Entuitive
              xw.writeElement('Carrier','HAL');  //Entuitive
              xw.writeElement('Carrier','ECON'); //Entuitive
            }else{
              xw.writeElement('Carrier','WAWA');
              xw.writeElement('Carrier','GORE'); //Entuitive
              xw.writeElement('Carrier','GA');   //Entuitive
              //xw.writeElement('Carrier','TRG');  
              xw.writeElement('Carrier','CIC');
              xw.writeElement('Carrier','HAL');  //Entuitive
              xw.writeElement('Carrier','DOC');
              xw.writeElement('Carrier','CAA');

              //    Carriers disabled due to change in contracting:
              // xw.writeElement('Carrier','ECON'); //Entuitive
            }
          }
          
          xw.endElement(); // End 'Carriers'
          xw.startElement( 'CodeNames' );
            xw.startElement( 'Auto' );
              xw.startElement( 'QuoteInfo' );
                if (method === 'Rate') {

                  xw.startElement( 'ContractNumber' );
                  xw.writeAttribute( 'vorTRG', 'A2000020233');
                  xw.writeAttribute( 'vorGA', 'A1000030903');
                  xw.writeAttribute( 'vorCAA', '200-001');
                  xw.writeAttribute( 'vorHAL3', '55332');
                  xw.writeAttribute( 'vorHAL', '55514');
                  xw.writeAttribute( 'vorPEM', 'A1000030903');
                  xw.writeAttribute( 'vorECGL', '1339-010');
                  // xw.writeAttribute( 'vorECGL', 'A1000030903');
                  xw.writeAttribute( 'vorWAWA', '0781567');
                  xw.writeAttribute( 'vorCIC', '6755561');
                  xw.writeAttribute( 'vorDOC', '6755561');
                  xw.writeAttribute( 'vorSGI', '1554-01');
                  xw.writeAttribute( 'vorCOA', '1553-01');
                  xw.writeAttribute( 'vorECON', '6845');
                  xw.writeAttribute( 'vorGORE', '3464');
                  // xw.writeAttribute( 'vorGA', 'A1000030903');
                  // xw.writeAttribute( 'vorHAL3', '55332');
                  // xw.writeAttribute( 'vorHAL', '55514');
                  // xw.writeAttribute( 'vorDOC', '6755561');
                  // xw.writeAttribute( 'vorCIC', '1234ABCD');
                  // xw.writeAttribute( 'vorROY', '151747842');
                  // xw.writeAttribute( 'vorCAA', '200-001');
                  // xw.writeAttribute( 'vorECON', '6465');
                  xw.endElement(); // End 'Contract Number'
                }
                xw.writeElement( 'ID', 'QUO1');
                xw.writeElement( 'TermRequested', '12');

                if(fields.user.cmbp.value === "true"){
                  xw.writeElement( 'CombinedPolicy', 'A');
                  xw.writeElement( 'HabPolicyType', 'Homeowners');
                  xw.writeElement( 'NoMVD', 'Y');
                }
                // xw.writeElement( 'AssumeMultiLine', 'N');
                xw.writeElement( 'CoverageOverride', 'More');
                xw.writeElement( 'Language', 'English');

                //drivers

                for(var i = 0;i < fields.drivs.values.length; i++){

                    var driverid = i + 1;

                    for (var c = 0; c < fields.drivs.values[i].tikts.values.length; c++) {

                        var convid = c + 1;

                        xw.startElement( 'Conviction' );
                        xw.writeElement( 'ID', 'TCK'+ convid )
                        xw.writeElement( 'DriverID', 'DRI'+ driverid )
                        xw.writeElement( 'Severity', fields.drivs.values[i].tikts.values[c].ofco.value.split('-')[0])
                        xw.writeElement( 'OffenceCode', fields.drivs.values[i].tikts.values[c].ofco.value.split('-')[1])
                        xw.writeElement( 'ConvictionDate', fields.drivs.values[i].tikts.values[c].codt.value )
                        xw.endElement(); // End 'Conviction'
                    
                    }

                    for (var c = 0 ; c < fields.drivs.values[i].clams.values.length; c++) {

                        var clmvid = c + 1;

                        xw.startElement( 'Claim' );
                        xw.writeElement( 'ID', 'CLM' + clmvid )
                        xw.writeElement( 'DriverID', 'DRI' + driverid )
                        xw.writeElement( 'VehicleID', 'VEH' + driverid )
                        xw.writeElement( 'ClaimType', fields.drivs.values[i].clams.values[c].clty.value )
                        xw.writeElement( 'ClaimDate', fields.drivs.values[i].clams.values[c].cldt.value )
                        xw.endElement(); // End 'Claim'
                    
                    }

                    for (var c = 0 ;c < fields.drivs.values[i].lapss.values.length; c++) {

                        var incid = c + 1;

                        xw.startElement( 'Incident' );
                        xw.writeElement( 'ID', 'LPS' + incid )
                        xw.writeElement( 'DriverID', 'DRI' + driverid )
                        xw.writeElement( 'Reason', fields.drivs.values[i].lapss.values[c].rson.value.split('?')[1] )
                        xw.writeElement( 'IncidentType', fields.drivs.values[i].lapss.values[c].rson.value.split('?')[0] )
                        xw.writeElement( 'IncidentDate', fields.drivs.values[i].lapss.values[c].indt.value )
                        xw.endElement(); // End 'Incident'
                    
                    }
                    var birth =  moment().subtract(fields.drivs.values[i].brth.value, 'year')
                    xw.startElement( 'DriverProfile' );
                        xw.writeElement( 'ID', 'DRI'+driverid )
                        xw.writeElement( 'Birthdate', birth.format('YYYYMMDD'))
                        xw.writeElement( 'Gender', fields.drivs.values[i].gend.value )
                        xw.writeElement( 'MaritalStatus', fields.drivs.values[i].mrst.value )
                        xw.writeElement( 'MotoAdvancedTraining', fields.drivs.values[i].mtat.value )
                        xw.writeElement( 'PostSecDegree', fields.drivs.values[i].pssd.value )
                        xw.writeElement( 'RelationshipToApplicant', fields.drivs.values[i].rtap.value )
                        xw.writeElement( 'Retired', (parseInt(fields.drivs.values[i].brth.value) < 65) ? "N" : "Y" )
                        xw.writeElement( 'DriverTraining', fields.drivs.values[i].drtr.value )
                        if (fields.drivs.values[i].dtci.value !== '0') {
                            xw.writeElement( 'DateContinuousInsurance', moment().subtract(fields.drivs.values[i].dtci.value,'year').format('YYYYMMDD'))
                        }
                        
                        var lics = ['G1', 'G2', 'G'];
                        var numL = parseInt(lics.indexOf(fields.drivs.values[i].drli.value))+1;
                        

                        var license = moment(fields.drivs.values[i].drld.value, 'YYYYMMDD');

                        xw.startElement( 'DriverLicense' );
                            xw.writeElement( 'ID', '1');
                            xw.writeElement('LicenseClass', fields.drivs.values[i].drli.value ); 
                            xw.writeElement('LicenseDate', (license.diff(birth,'years') < 15)?moment(birth).add(16,'years').format('YYYYMMDD'):license.format('YYYYMMDD'));
                            xw.writeElement('Country', 'CA' );
                            xw.writeElement('ProvinceState', 'ON' );
                        xw.endElement(); // End 'DriverLicense'

                        // for (var ii=numL-1;ii>=0;ii--) {
                        //     xw.startElement( 'DriverLicense' );
                        //     xw.writeElement( 'ID', 'LIC' + ii);
                        //     xw.writeElement('LicenseClass', lics[ii] ); 
                        //     xw.writeElement('LicenseDate', moment(fields.drivs.values[i].drld.value, 'YYYYMMDD').subtract((numL-ii-1), 'year').format('YYYYMMDD'));
                        //     xw.writeElement('Country', 'CA' );
                        //     xw.writeElement('ProvinceState', 'ON' );
                        //     xw.endElement(); // End 'DriverLicense'
                        // }
                        
                        if ((driverid === 0) && (method === 'Rate')) {

                            xw.startElement( 'GroupPlan' );
                            xw.writeElement( 'ID', 'GroupPlan1' )
                            // xw.writeElement( 'DateMembership', '19870402' )
                            xw.writeElement( 'GroupPlanDescr', 'CAA' )
                            xw.writeElement( 'VehType', 'Private Passenger' )
                            xw.endElement(); // End 'GroupPlan'

                        }
                        xw.endElement(); // End 'DriverProfile'
                }
                
                for (var j = 0 ; j < fields.vhcls.values.length; j++) {

                var vehid = j + 1;

                xw.startElement( 'Vehicle' );
                    xw.writeElement( 'ID', 'VEH'+ vehid );
                    xw.writeElement( 'Year', fields.vhcls.values[j].year.value);
                    xw.writeElement( 'Manufacturer', fields.vhcls.values[j].manu.value );
                    xw.writeElement( 'MakeAndModel', fields.vhcls.values[j].mkmd.value );
                    xw.writeElement( 'VICCCode', fields.vhcls.values[j].vicc.value );
                    xw.writeElement( 'VICCCodeExt', fields.vhcls.values[j].vice.value );
                    xw.writeElement( 'Owned', fields.vhcls.values[j].puco.value.slice(0,1) );
                    xw.writeElement( 'PurchaseCondition', fields.vhcls.values[j].puco.value.slice(1,2) )
                    xw.writeElement( 'PurchaseDate', fields.vhcls.values[j].pudt.value )
                    xw.writeElement( 'PostalCode', fields.user.post.value )
                    xw.writeElement( 'ProductLine', 'Personal')
                    xw.writeElement( 'Location', fields.user.loca.value )
                    xw.writeElement( 'LocationIndex', fields.user.loin.value )
                    xw.writeElement( 'DistanceYearly',  fields.vhcls.values[j].diyr.value)
                    xw.writeElement( 'DistanceDaily',  fields.vhcls.values[j].didl.value)
                    xw.writeElement( 'BodyType', fields.vhcls.values[j].bdty.value)
                    xw.writeElement( 'FuelType', (fields.vhcls.values[j].flTy.value === "V")?"2":"3")
                    xw.writeElement( 'Hybrid', (fields.vhcls.values[j].hybd.value.length > 0)?fields.vhcls.values[j].hybd.value:"N")
                    xw.writeElement( 'nCylinders', fields.vhcls.values[j].ncyl.value)
                    xw.writeElement( 'ValueNew', fields.vhcls.values[j].vnew.value)
                    xw.writeElement( 'VehType', 'Private Passenger')
                    xw.writeElement( 'VehUse', 'Pleasure')
                    xw.writeElement( 'WinterTires', 'N')
                    // xw.writeElement( 'WinterTires', getResponse('s_wint_1'))
                    // Standard Coverage
                    
                    for(var cv = 0; cv < fields.vhcls.values[j].cvrgs.values.length; cv++){
                        xw.startElement( 'Coverage' );
                          xw.writeElement( 'ID', 'VEH' + vehid + '-' + fields.vhcls.values[j].cvrgs.values[cv].csio.value);
                          xw.writeElement( 'CSIOCode', fields.vhcls.values[j].cvrgs.values[cv].csio.value );
                          if(fields.vhcls.values[j].cvrgs.values[cv].lmt1.value.length > 0) xw.writeElement( 'Limit1', fields.vhcls.values[j].cvrgs.values[cv].lmt1.value );
                          if(fields.vhcls.values[j].cvrgs.values[cv].lmt2.value.length > 0) xw.writeElement( 'Limit2', fields.vhcls.values[j].cvrgs.values[cv].lmt2.value );
                          if(fields.vhcls.values[j].cvrgs.values[cv].dedu.value.length > 0) xw.writeElement( 'Deductible', fields.vhcls.values[j].cvrgs.values[cv].dedu.value );
                        xw.endElement(); // End 'Coverage'
                    }
                xw.endElement(); // End 'Vehicle'
                }
                
                var numD = fields.drivs.values.length;
                var numV = fields.vhcls.values.length;
                
                if (numV >= numD) {
                  for (var k = 1 ; k <= numV; k++) {
                    xw.startElement( 'VehLink' );
                      xw.writeElement( 'ID', 'LIN'+k );
                      xw.writeElement( 'VehicleID', 'VEH'+k );
                      xw.writeElement( 'DriverID', 'DRI'+(((k - 1) % numD) + 1));
                      xw.writeElement( 'Link', 'Prn' );
                    xw.endElement(); // End 'VehLink'
                  }
                } else {
                  for (var k=1;k<=numD;k++) {
                    xw.startElement( 'VehLink' );
                      xw.writeElement( 'ID', 'LIN'+k );
                      xw.writeElement( 'VehicleID', 'VEH'+(((k - 1) % numV) + 1) );
                      xw.writeElement( 'DriverID', 'DRI'+k);
                      xw.writeElement( 'Link', (k<=numV?'Prn':'Occ') );
                    xw.endElement(); // End 'VehLink'
                  }
                }
                
              xw.endElement(); // End 'QuoteInfo'
            xw.endElement(); // End 'Auto'
          xw.endElement(); // End 'CodeNames'
        xw.endElement(); // End 'FortusTransaction'
        
        if (method === 'RecordFortusLead') {
          xw.endElement( 'FortusQuote' );
          xw.startElement( 'FortusExtended' );
        }
        if (method !== 'RecordFortusLead') {
          xw.endElement(); // End 'xmlparam_FortusTransaction'
        }
        
      if (method === 'Rate' || method === 'RecordFortusLead') {

        xw.startElement( 'xmlparam_ExtendedInput' )
          xw.startElement( 'FortusTransaction' )
            xw.writeAttribute( 'xmlns', 'deletethis' );
            xw.startElement( 'Carriers' )
            xw.endElement();
            xw.writeElement( 'Province', 'ON' );
            xw.writeElement( 'QuoteGUID', guid );
            xw.startElement( 'CodeNames' )
              xw.startElement( 'Auto' )
                xw.startElement( 'QuoteInfo' )
                  xw.writeElement( 'Origin', 'myinsurancebroker.com' );
                  xw.startElement( 'Client' )
                    xw.writeElement( 'ID', 'CLI1' );
                    xw.startElement( 'Address' )
                      xw.writeElement('ID', 'ADR1')
                      xw.writeElement('Classification', 'Client')
                      xw.writeElement('Address1', '123 Online Quoter')
                      xw.writeElement('Province', 'ON')
                      xw.writeElement( 'PostalCode', fields.user.post.value )
                      xw.writeElement( 'City', 'Toronto' )
                    xw.endElement(); // End 'Address'
                    xw.startElement( 'Name' )
                      xw.writeElement( 'ID', 'NAM1' )
                      xw.writeElement( 'Classification', 'Client' )
                      xw.writeElement( 'FirstName', fields.user.frst.value )
                      xw.writeElement( 'LastName', fields.user.last.value )
                    xw.endElement(); // End 'Name'
                    xw.startElement( 'Telephone' )
                      xw.writeElement( 'ID', 'PHO1' )
                      xw.writeElement( 'Classification', 'Home' )
                      xw.writeElement( 'AreaCode', fields.user.phne.value.slice(0,3) )
                      xw.writeElement( 'Number', fields.user.phne.value.slice(3) )
                    xw.endElement(); // End 'Telephone'
                  xw.endElement(); // End 'Client'
                  xw.startElement( 'CreditScore' )
                    // xw.writeElement( 'ID', 'SCO1' );
                    // xw.startElement( 'Address' )
                    //   xw.writeElement('ID', 'ADR1')
                    //   xw.writeElement('Classification', 'Insured')
                    //   xw.writeElement('Address1', fields.user.add1.value)
                    //   xw.writeElement( 'PostalCode', fields.user.post.value )
                    //   xw.writeElement( 'City', fields.vhcls.values[0].loca.value )
                    //   xw.writeElement('Province', 'ON')
                    // xw.endElement(); // End 'Address'
                    // xw.writeElement( 'Birthdate', fields.drivs.values[0].brth.value )
                    // xw.startElement( 'Name' )
                    //   xw.writeElement( 'ID', 'NAM1' )
                    //   xw.writeElement( 'Classification', 'Insured' )
                    //   xw.writeElement( 'FirstName', fields.user.frst.value )
                    //   xw.writeElement( 'LastName', fields.user.last.value )
                    // xw.endElement(); // End 'Name'
                    // xw.writeElement( 'PartyType', 'IN' )
                    // xw.startElement( 'Telephone' )
                    //   xw.writeElement( 'ID', 'PHO1' )
                    //   xw.writeElement( 'Classification', 'Insured' )
                    //   xw.writeElement( 'AreaCode', fields.user.phne.value.slice(0,3) )
                    //   xw.writeElement( 'Number', fields.user.phne.value.slice(3) )
                    // xw.endElement(); // End 'Telephone'
                  xw.endElement(); // End 'Credit Score'
                  xw.startElement( 'DriverProfile' )
                    xw.writeElement( 'ID', 'DRI1' )
                    xw.startElement( 'Name' )
                      xw.writeElement( 'ID', 'NAM1' )
                      xw.writeElement( 'Classification', 'Driver' )
                      xw.writeElement( 'FirstName', fields.user.frst.value )
                      xw.writeElement( 'LastName', fields.user.last.value )
                    xw.endElement(); // End 'Name'
                    // xw.startElement( 'GroupPlan' )
                    //   xw.writeElement( 'ID', 'GroupPlan1' )
                    //   xw.writeElement( 'MembershipNumber', fields.user.mmnb.value )
                    // xw.endElement(); // End 'GroupPlan'
                  xw.endElement(); // End 'DriverProfile'
                xw.endElement(); // End 'QuoteInfo'
              xw.endElement(); // End 'Auto'
            xw.endElement(); // End 'CodeNames'
          xw.endElement(); // End 'FortusTransaction'
        xw.endElement(); // End 'xmlparam_ExtendedInput'

        xw.startElement( 'xmlparam_CarrierInfo' )
          xw.startElement( 'RBCarrierInfo' )
            xw.writeAttribute( 'xmlns', 'deletethis' );
            xw.startElement( 'Group' )
              xw.startElement( 'Carriers' )
                if(fields.user.brkr.value == "MIBF2"){
                  xw.startElement( 'HAL' )
                  xw.endElement();
                  xw.startElement( 'ECON' )
                  xw.endElement();
                }else{
                  xw.startElement( 'HAL' )
                  xw.endElement();
                  xw.startElement( 'CIC' )
                  xw.endElement();
                  xw.startElement( 'DOC' )
                  xw.endElement();
                  xw.startElement( 'CAA' )
                  xw.endElement();
                }
              xw.endElement(); // End 'Carriers'
              xw.startElement( 'Credentials' )
                xw.writeElement( 'UserName', 'xxx' )
                xw.writeElement( 'Password', 'xxx' )
              xw.endElement(); // End 'Credentials'
              xw.writeElement( 'Consent', 'Y' )
            xw.endElement(); // End 'Group'
            xw.startElement( 'OtherCreds' )
            xw.endElement();
            // xw.startElement( 'Group' )
            //   xw.startElement( 'Carriers' )
            //     xw.startElement( 'GA' )
            //     xw.endElement();
            //   xw.endElement(); // End 'Carriers'
            //   xw.startElement( 'Credentials' )
            //     xw.writeElement( 'UserName', 'GAUN' )
            //     xw.writeElement( 'Password', 'GAPW' )
            //   xw.endElement(); // End 'Credentials'
            //   xw.writeElement( 'Consent', 'Y' )
            // xw.endElement(); // End 'Group'
            // xw.startElement( 'Group' )
            //   xw.startElement( 'Carriers' )
            //     xw.startElement( 'WAWA' )
            //     xw.endElement();
            //   xw.endElement(); // End 'Carriers'
            //   xw.startElement( 'Credentials' )
            //     xw.writeElement( 'UserName', 'WAWAUN' )
            //     xw.writeElement( 'Password', 'WAWAPW' )
            //   xw.endElement(); // End 'Credentials'
            //   xw.writeElement( 'Consent', 'Y' )
            // xw.endElement(); // End 'Group'
            // xw.startElement( 'Group' )
            //   xw.startElement( 'Carriers' )
            //     xw.startElement( 'GORE' )
            //     xw.endElement();
            //   xw.endElement(); // End 'Carriers'
            //   xw.startElement( 'Credentials' )
            //     xw.writeElement( 'UserName', 'GOREUN' )
            //     xw.writeElement( 'Password', 'GOREPW' )
            //   xw.endElement(); // End 'Credentials'
            //   xw.writeElement( 'Consent', 'Y' )
            // xw.endElement(); // End 'Group'
            // xw.startElement( 'Group' )
            //   xw.startElement( 'Carriers' )
            //     xw.startElement( 'ECON' )
            //     xw.endElement();
            //   xw.endElement(); // End 'Carriers'
            //   xw.startElement( 'Credentials' )
            //     xw.writeElement( 'ContractCode', '6465' )
            //     xw.writeElement( 'UserName', 'q10' )
            //     xw.writeElement( 'Password', 'spyro201' )
            //   xw.endElement(); // End 'Credentials'
            //   xw.startElement( 'Additional' )
            //     xw.writeElement( 'CorrespondLanguage', 'E' )
            //   xw.endElement(); // End 'Additional'
            //   xw.writeElement( 'Consent', 'Y' )
            // xw.endElement(); // End 'Group'
          xw.endElement(); // End 'RBCarrierInfo'
        xw.endElement(); // End 'xmlparam_CarrierInfo'

      }
      
      if (method === 'RecordFortusLead') {
        xw.endElement( 'FortusExtended' );
      }
      
    xw.endElement(); // End 'Quote' OR 'Rate'
    xw.endDocument();
    
    // console.log(xw.flush().replace('<?xml version="1.0" encoding="UTF-8" ?>\n',''));
    return xw.toString().replace('<?xml version="1.0"?>\n','').replaceAll('deletethis','');

  }

export function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return ((c === 'x') ? r : ((r & 0x3) | 0x8)).toString(16);
    });
}